<template>
    <div class="quick common-card" @click="isDelete = false">
        <div class="card-title">
            <p>便捷入口</p>
            <div class="card-title--right">
                <!-- <el-select class="card-title--right--select" v-model="selectValue">
                    <el-option value="1" label="常用"></el-option>
                </el-select> -->
                <!-- <span class="card-title--right--line"></span> -->
                <el-button 
                    type="text" 
                    @click.stop="manageHandle"
                >管理</el-button>
            </div>
        </div>
        <div class="common-content" v-loading="loading">
            <div class="quick-content hidden-content scroll_hidden" @mouseover="mymouseIn" @mouseout="mymouseOut">
                <div class="quick-item" v-for="item in dataList" :key="item.id" @click.stop="routerHandle(item)">
                    <span class="quick-icon">
                        <img :src="item.appIcon" alt="" v-if="item.appIcon">
                        <img :src="require(`@/assets/images/default-icon.png`)" v-else alt="" srcset="">
                    </span>
                    <span class="quick-name" :title="item.appName">{{item.appName }}</span>
                    <span class="quick-delete" v-if="isDelete" @click.stop="deleteData(item)"></span>
                </div>
                <div class="quick-item quick-item--add" @click.stop="addHandle">
                    <i class="el-icon-circle-plus-outline"></i>
                    添加常用链接
                </div>
            </div>
        </div>
        <AddSystem ref="AddSystem" @on-close="dialogCancel"></AddSystem>
    </div>
</template>

<script>
import {apiShortcutList,shortCutDelete} from '@/server/new.js';
import AddSystem from '@/views/common/components/common/AddSystem'; 
export default {
    components: {
        AddSystem
    },
    data() {
        return {
            loading: false,
            selectValue: '',
            dataList: [],
            isDelete: false
        }
    },
    mounted() {
        this.apiShortcutList();
    },
    methods: {
        apiShortcutList() { //获取数据
            this.loading = true;
            apiShortcutList().then(({data}) => {
                this.dataList = data.rows || [];
            }).finally(() => { this.loading = false; })
        },
        manageHandle() { //管理按钮-每一项增加删除按钮
            this.isDelete = !this.isDelete;
        },
        dialogCancel() { //弹框关闭
            this.apiShortcutList();
        },
        addHandle() { //添加按钮
            this.$refs.AddSystem.apiwbsystemconfiggetSystemConfigList();
        },
        deleteData(row) { //删除
            this.$confirm('是否删除本条记录？', '提示', {
                confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
            }).then(() => {
                shortCutDelete({id: row.id}).then(({data}) => {
                    if(data.code === '1') {
                        this.apiShortcutList();
                    }else {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        routerHandle(row) { //跳转
            if(row.openMod === 9 && row.appId) {
                window.open(`${row.redirectUrl}?token=${this.$cookie.get('access_token')}`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.quick {
    margin-bottom: 0;
    .card-title {
        .card-title--right {
            margin-left: auto;
            display: flex;
            align-items: center;
            .card-title--right--select {
                max-width: 128px;
            }
            .card-title--right--line {
                width: 1px;
                height: 16px;
                background-color: rgba(0,0,0,.25);
                margin: 0 12px;
            }
        }
    }
    .quick-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: flex-start;
        padding: 20px 10px;
        .quick-item {
            width: calc(50% - 8px);
            max-height: 48px;
            height: 48px;
            background: #F6F8FA;
            padding: 14px 18px 14px 12px;
            cursor: pointer;
            border-radius: 2px;
            // border: 1px solid #979797;
            margin: 0 16px 16px 0;
            position: relative;
            display: flex;
            align-items: center;
            span {
                display: inline-block;
            }
            .quick-icon {
                margin-right: 8px;
                width: 20px;
                height: 20px;
                img {
                    width: 20px;
                    height: 20px;
                }
            }
            .quick-name {
                width: calc(100% - 20px);
                overflow: hidden;/*超出部分隐藏*/
                text-overflow:ellipsis;/* 超出部分显示省略号 */
                white-space: nowrap;/*规定段落中的文本不进行换行 */
            }
            .quick-delete {
                width: 48px;
                height: 48px;
                position: absolute;
                right: 0;
                top: -1px;
                border-radius: 0px 2px 2px 0px;
                background: #FA9596 url('../../../../assets/images/home/delete_icon.png') no-repeat;
				background-position: center center;
            }
            &:nth-child(2n) {
                margin-right: 0;
            }
            &:hover {
                border-color: @--color-primary;
                color: @--color-primary;
                box-shadow: 0 1px 10px 0 rgba(0,0,0,.12), 0 4px 5px 0 rgba(0,0,0,.08), 0 2px 4px -1px rgba(0,0,0,.05);
            }
            &.quick-item--add {
                padding: 0;
                justify-content: center;
                color: rgba(0,0,0,.65);
                border: 1px dashed #C2CDE2;
                &:hover {
                    color: @--color-primary;
                }
                i {
                    margin-right: 9px;
                    color: rgba(0,0,0,.45);
                    font-weight: bold;
                }
            }
        }
    }
}
</style>